import { Button } from '@heroui/button'
import { Image } from '@heroui/image'
import { Modal, ModalBody, ModalContent } from '@heroui/modal'
import { Skeleton } from '@heroui/skeleton'

import { CrossIcon } from '@/components/shared'
import { cn } from '@/utils'

interface ImageModalProps {
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
  image: string
  aspectRatio?: number
}

const ImageModal = ({
  isOpen,
  onOpenChange,
  image,
  aspectRatio,
}: ImageModalProps) => {
  return (
    <Modal
      size="full"
      isOpen={isOpen && !!image}
      onOpenChange={onOpenChange}
      hideCloseButton
      classNames={{
        body: 'flex justify-center items-center relative',
      }}
    >
      <ModalContent>
        {(onClose) => (
          <ModalBody>
            <Button
              isIconOnly
              size="md"
              variant="solid"
              radius="full"
              color="default"
              className="absolute right-5 top-5 bg-default-100 text-2xl"
              onPress={onClose}
            >
              <CrossIcon />
            </Button>
            {image ? (
              <Image
                src={image}
                alt="image"
                classNames={{
                  wrapper: 'w-3/4 md:w-1/2 !max-w-[640px]',
                }}
              />
            ) : (
              <Skeleton
                className={cn(
                  'w-3/4 !max-w-[640px] md:w-1/2',
                  aspectRatio ? `aspect-[${aspectRatio}]` : 'aspect-square',
                )}
              />
            )}
          </ModalBody>
        )}
      </ModalContent>
    </Modal>
  )
}

export default ImageModal
